module.exports = __webpack_public_path__ + "img/AI-desc.0cd7e7ef.png";